<template>
    <div>
        {{ $t('notification.formDownloaded', { 
            user: $_.get(activity, 'actorUser.name'), 
            formName: $_.get(activity, 'payload.formName'),
            formId: $_.get(activity, 'payload.formId')
        }) }}
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "FormDownloaded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

